

















import { CloseProjectCommand, SuspendProjectCommand } from "@/api/project-api";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IProjectListItem } from "./VProjectList.vue";
import { isNewProject } from "@/preferences";
import CloseDateModal from "@/ui/order/components/CloseDateModal.vue";
import { getStatusCode } from "@/status";

interface Action {
  id: string;
  label: string;
  click: (item: IProjectListItem) => unknown;
  disabled?: boolean;
}

@Component({
  components: {
    CloseDateModal
  }
})
export default class ProjectListActions extends Vue {
  @Prop({ required: true }) item!: IProjectListItem;

  get actions(): Action[] {
    const actions: Action[] = [
      {
        id: "suspend",
        label: "保留にする",
        disabled: isNewProject(this.item.createdAt)
          ? this.item.statusProject == getStatusCode("保留", true) ||
            this.item.closed
          : !["未着工", "施工前", "施工中"].includes(this.item.status),
        click: item => {
          if (
            !confirm(
              "現場内の全ての工程が保留になります。本当に実行してもよろしいですか？"
            )
          ) {
            return;
          }
          const command: SuspendProjectCommand = {
            id: Number(item.project.id),
            pending: true
          };
          this.$emit("suspend", command);
        }
      },
      {
        id: "unsuspend",
        label: "保留を解除する",
        disabled: isNewProject(this.item.createdAt)
          ? this.item.statusProject != getStatusCode("保留", true)
          : !["保留"].includes(this.item.status),
        click: item => {
          const command: SuspendProjectCommand = {
            id: Number(item.project.id),
            pending: false
          };
          this.$emit("suspend", command);
        }
      },
      {
        id: "close",
        label: "現場を終了にする",
        disabled: this.item.closed,
        click: item => {
          if (isNewProject(item.createdAt)) {
            this.$emit("showModal", item);

            return;
          }

          if (!confirm("本当に現場を終了してもよろしいですか？")) {
            return;
          }
          const command: CloseProjectCommand = {
            id: Number(item.project.id),
            closed: true
          };
          this.$emit("close", command);
        }
      },
      {
        id: "open",
        label: "終了した現場を再開する",
        disabled: !this.item.closed,
        click: item => {
          const command: CloseProjectCommand = {
            id: Number(item.project.id),
            closed: false
          };
          if (isNewProject(item.createdAt)) {
            command.endDate = "";
          }
          this.$emit("close", command);
        }
      }
    ];
    return actions.filter(a => !a.disabled);
  }
}
